import { ReactNode } from "react";
import styles from "./Highlight.module.css";

function Highlight({ children }: { children: ReactNode }) {
  return <div className={styles["root"]}>{children}</div>;
}

export default Highlight;
